var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 12.501H12.5M2.5 12.501V10.001L7.5 5.00105M2.5 12.501H5L10 7.50104M7.5 5.00105L9.29287 3.20814L9.294 3.20707C9.54075 2.96027 9.66437 2.83666 9.80687 2.79036C9.93244 2.74957 10.0676 2.74957 10.1932 2.79036C10.3356 2.83662 10.4591 2.9601 10.7055 3.20655L11.7929 4.29393C12.0404 4.54144 12.1642 4.66525 12.2106 4.80796C12.2514 4.93348 12.2513 5.06869 12.2106 5.19423C12.1642 5.33683 12.0406 5.46045 11.7934 5.70761L11.7929 5.70814L10 7.50104M7.5 5.00105L10 7.50104",
    stroke: "#596371",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditlogo);
export default __webpack_public_path__ + "static/media/editlogo.76013047ac4dad3ca64dee5f3c262285.svg";
export { ForwardRef as ReactComponent };